import type { PingKind } from '../../shared/network/pings.js';
import { mixer } from './audio-mixer.js';
import { levelOf } from './mix.js';

/**
 * Whether Vite bundled this module. Clips load through a glob (a variable `new URL` in a subfolder resolves to `undefined` in the browser, see
 * `critter-sounds.ts`); the Node test runner reads the listed files by path.
 */
const bundled = import.meta.env !== undefined;
const files = bundled ? import.meta.glob('../assets/audio/sfx/ping/*.mp3', { eager: true, query: '?url', import: 'default' }) as Record<string, string> : {};
const clip = (name: string) => bundled ? files[`../assets/audio/sfx/ping/${name}.mp3`] : new URL(`../assets/audio/sfx/ping/${name}.mp3`, import.meta.url).href;

/** The recordings of each ping kind: a soft chime for every plain ping, a ship's bell for Danger. */
const CHIME = [clip('chime 1')];
const RECORDINGS: Record<PingKind, readonly string[]> = { mark: CHIME, rally: CHIME, watch: CHIME, attack: CHIME, defend: CHIME, heal: CHIME, danger: [clip('danger 1')] };

export const pingRecordings: readonly string[] = [...new Set(Object.values(RECORDINGS).flat())];
export const preloadPingSounds = () => mixer.preloadSfx([...pingRecordings]);

/** Sounds a ping dropped on the map, for every player, at its kind's level. */
export function playPing(kind: PingKind, random: () => number = Math.random) {
  const urls = RECORDINGS[kind];
  if (urls.length) mixer.playEffect(urls[Math.min(urls.length - 1, Math.floor(random() * urls.length))], 'ping', levelOf('ping'), 1);
}
